import type { EmotionCache } from '@emotion/cache';
import createCache from '@emotion/cache';

const emotionCacheKey = 'custom';

const createEmotionCache = () => {
  const cache = createCache({
    key: emotionCacheKey,
  });

  // NOTE: compatモードにしてデフォルトのSSR時の警告を消す。
  // SSRを利用するcreateEmotionServer()内ではこのフラグを立てているが、
  // クライアント側ではその関数を利用しないため代わりにここでフラグを立てる。
  cache.compat = true;

  return cache;
};

// NOTE: サーバ側ではレスポンスごとにemotionのキャッシュを破棄する必要があるが、
// _app.jsでも最新のemotionのキャッシュを参照する必要があるため、
// ここにキャッシュを保持するオブジェクトを置く
export class EmotionCacheHandle {
  static _cache: null | EmotionCache = null;

  static get() {
    if (!this._cache) {
      this._cache = createEmotionCache();
    }

    return this._cache;
  }

  static clear() {
    this._cache = null;
  }
}
